import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/root-reducer';
import { selectPaddleCustomerId } from '../../../components/home/home-slice';
import { initializePaddle } from '../../utils';

interface UsePaddleIntegrationWithConfigProps {
  enable?: boolean;
  token?: string;
  onError?: (error: any) => void;
}

const usePaddleIntegrationWithConfig = ({
  enable = true,
  onError,
}: UsePaddleIntegrationWithConfigProps = {}) => {
  const token = process.env.REACT_APP_CFG_PAY_02;

  const paymentProvider = useSelector(
    (state: RootState) => state.home?.paymentProvider,
  );
  const paddleCustomerId = useSelector(selectPaddleCustomerId);
  const customerId = useMemo(() => {
    if (paymentProvider === 'paddle' && paddleCustomerId) {
      return paddleCustomerId;
    }

    return '';
  }, [paymentProvider, paddleCustomerId]);
  useEffect(() => {
    if (!enable) return;

    try {
      if (token) {
        initializePaddle(token, customerId || '');
      }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.error('Error initializing Paddle:', error);
      }
      onError?.(error);
    }
  }, [enable, token, customerId, onError]);

  return null;
};

export default usePaddleIntegrationWithConfig;
